import type { SalesOrderSearchQuery } from './-query/type';

export const OrderBy = {
  ACCEPTED_DATE: 'ACCEPTED_DATE',
  ORDER_NUMBER: 'ORDER_NUMBER',
  ORDERED_BY_PERSON: 'ORDERED_BY_PERSON',
  CUSTOMER: 'CUSTOMER',
  SUPPLIER: 'SUPPLIER',
  DELIVERY_DATE: 'DELIVERY_DATE',
} as const satisfies Record<string, SalesOrderSearchQuery['orderBy']>;

export const Category = {
  UNTOUCHED: 'UNTOUCHED',
  ACCEPTED: 'ACCEPTED',
  CANCELED: 'CANCELED',
  ALL: 'ALL',
} as const satisfies Record<string, SalesOrderSearchQuery['category']>;
